"use strict";

document.addEventListener("DOMContentLoaded", () => {
  initBrandsSections();
});

document.addEventListener("shopify:section:load", (event) => {
  initBrandsSections(event.target);
});

function initBrandsSections(scope = document) {
  const sections = scope.querySelectorAll("[data-brands-section]");

  sections.forEach((section) => {
    if (section.dataset.brandsSectionBound === "true") {
      return;
    }

    section.dataset.brandsSectionBound = "true";

    const viewport = section.querySelector("[data-brands-viewport]");
    const track = section.querySelector("[data-brands-track]");
    const group = section.querySelector("[data-brands-group]");

    if (!viewport || !track || !group) {
      return;
    }

    const runSetup = () => {
      waitForBrandImages(section).then(() => {
        window.requestAnimationFrame(() => {
          setupBrandsSlider(section, viewport, track, group);
        });
      });
    };

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            observer.disconnect();
            runSetup();
          });
        },
        { rootMargin: "120px 0px" }
      );

      observer.observe(section);
      return;
    }

    runSetup();
  });
}

function waitForBrandImages(section) {
  const images = section.querySelectorAll("img");

  if (!images.length) {
    return Promise.resolve();
  }

  return Promise.all(
    Array.from(images).map(
      (image) =>
        new Promise((resolve) => {
          if (image.complete) {
            resolve();
            return;
          }

          const finish = () => resolve();
          image.addEventListener("load", finish, { once: true });
          image.addEventListener("error", finish, { once: true });
        })
    )
  );
}

function resetBrandsSlider(section, track) {
  section.classList.remove("is-ready");
  track.style.removeProperty("--brands-scroll-distance");
  track.style.removeProperty("--brands-scroll-duration");

  track.querySelectorAll("[data-brands-clone]").forEach((clone) => {
    clone.remove();
  });
}

function setupBrandsSlider(section, viewport, track, group) {
  resetBrandsSlider(section, track);

  const groupWidth = group.getBoundingClientRect().width;
  const viewportWidth = viewport.getBoundingClientRect().width;

  if (!groupWidth || !viewportWidth) {
    window.setTimeout(() => {
      setupBrandsSlider(section, viewport, track, group);
    }, 150);
    return;
  }

  const trackStyles = window.getComputedStyle(track);
  const gap = parseFloat(trackStyles.gap) || 0;

  const clone = group.cloneNode(true);
  clone.setAttribute("data-brands-clone", "true");
  clone.setAttribute("aria-hidden", "true");
  track.appendChild(clone);

  const distance = groupWidth + gap;
  const speed = parseFloat(section.dataset.speed) || 55;
  const duration = distance / speed;

  track.style.setProperty("--brands-scroll-distance", `-${distance}px`);
  track.style.setProperty("--brands-scroll-duration", `${duration}s`);

  window.requestAnimationFrame(() => {
    section.classList.add("is-ready");
  });

  if (section.dataset.brandsResizeBound === "true") {
    return;
  }

  section.dataset.brandsResizeBound = "true";

  let resizeFrame = null;

  const handleResize = () => {
    if (resizeFrame) {
      window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(() => {
      setupBrandsSlider(section, viewport, track, group);
    });
  };

  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(viewport);
    resizeObserver.observe(group);
  } else {
    window.addEventListener("resize", handleResize);
  }
}
